module.exports = __webpack_public_path__ + "static/media/behance.283479a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/behance.svg
// module id = 27
// module chunks = 0